import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FaHeart, FaDollarSign, FaCreditCard, FaPaypal } from 'react-icons/fa';
import './DonationBar.css';

const DonationBar = ({ goal, current, onDonate }) => {
  const [donationAmount, setDonationAmount] = useState('');
  const [showDonationForm, setShowDonationForm] = useState(false);
  const [selectedPayment, setSelectedPayment] = useState('card');

  const progress = Math.min((current / goal) * 100, 100);
  const remaining = goal - current;

  const handleDonate = (e) => {
    e.preventDefault();
    const amount = parseFloat(donationAmount);
    if (amount > 0) {
      onDonate(amount);
      setDonationAmount('');
      setShowDonationForm(false);
      alert(`Thank you for your donation of ₹${amount}! Your contribution will help children in need.`);
    }
  };

  const quickDonate = (amount) => {
    onDonate(amount);
    alert(`Thank you for your donation of ₹${amount}! Your contribution will help children in need.`);
  };

  return (
    <section id="donate" className="donation-section">
      <div className="container">
        <motion.div 
          className="donation-content"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <div className="donation-header">
            <h2 className="section-title">Help Us Reach Our Goal</h2>
            <p className="section-subtitle">
              Every rupee counts in our mission to help underprivileged children. 
              Your donation provides education, healthcare, and hope.
            </p>
          </div>

          <div className="donation-progress">
            <div className="progress-info">
              <div className="progress-stats">
                <div className="stat">
                  <span className="amount">₹{current.toLocaleString()}</span>
                  <span className="label">Raised</span>
                </div>
                <div className="stat">
                  <span className="amount">₹{remaining.toLocaleString()}</span>
                  <span className="label">To Go</span>
                </div>
                <div className="stat">
                  <span className="amount">₹{goal.toLocaleString()}</span>
                  <span className="label">Goal</span>
                </div>
              </div>
              
              <div className="progress-bar-container">
                <div className="progress-bar">
                  <motion.div 
                    className="progress-fill"
                    initial={{ width: 0 }}
                    whileInView={{ width: `${progress}%` }}
                    transition={{ duration: 1.5, ease: "easeOut" }}
                    viewport={{ once: true }}
                  ></motion.div>
                </div>
                <span className="progress-percentage">{Math.round(progress)}%</span>
              </div>
            </div>

            <div className="donation-actions">
              <div className="quick-donate">
                <h3>Quick Donate</h3>
                <div className="quick-amounts">
                  <button 
                    className="quick-btn"
                    onClick={() => quickDonate(500)}
                  >
                    ₹500
                  </button>
                  <button 
                    className="quick-btn"
                    onClick={() => quickDonate(1000)}
                  >
                    ₹1,000
                  </button>
                  <button 
                    className="quick-btn"
                    onClick={() => quickDonate(2500)}
                  >
                    ₹2,500
                  </button>
                  <button 
                    className="quick-btn"
                    onClick={() => quickDonate(5000)}
                  >
                    ₹5,000
                  </button>
                </div>
              </div>

              <div className="custom-donate">
                <button 
                  className="btn btn-primary custom-donate-btn"
                  onClick={() => setShowDonationForm(!showDonationForm)}
                >
                  <FaHeart /> Custom Amount
                </button>
              </div>
            </div>

            {showDonationForm && (
              <motion.div 
                className="donation-form"
                initial={{ opacity: 0, height: 0 }}
                animate={{ opacity: 1, height: 'auto' }}
                exit={{ opacity: 0, height: 0 }}
                transition={{ duration: 0.3 }}
              >
                <form onSubmit={handleDonate}>
                  <div className="form-group">
                    <label htmlFor="amount">Donation Amount (₹)</label>
                    <input
                      type="number"
                      id="amount"
                      value={donationAmount}
                      onChange={(e) => setDonationAmount(e.target.value)}
                      placeholder="Enter amount"
                      min="1"
                      step="1"
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label>Payment Method</label>
                    <div className="payment-methods">
                      <label className="payment-option">
                        <input
                          type="radio"
                          name="payment"
                          value="card"
                          checked={selectedPayment === 'card'}
                          onChange={(e) => setSelectedPayment(e.target.value)}
                        />
                        <FaCreditCard />
                        Credit Card
                      </label>
                      <label className="payment-option">
                        <input
                          type="radio"
                          name="payment"
                          value="paypal"
                          checked={selectedPayment === 'paypal'}
                          onChange={(e) => setSelectedPayment(e.target.value)}
                        />
                        <FaPaypal />
                        PayPal
                      </label>
                    </div>
                  </div>

                  <div className="form-actions">
                    <button type="submit" className="btn btn-primary">
                      <FaDollarSign /> Donate Now
                    </button>
                    <button 
                      type="button" 
                      className="btn btn-secondary"
                      onClick={() => setShowDonationForm(false)}
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              </motion.div>
            )}
          </div>

          
        </motion.div>
      </div>
    </section>
  );
};

export default DonationBar; 